import React from 'react'

const Illustration = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="458"
      height="455"
      viewBox="0 0 458 455"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-697 -321)">
          <g transform="translate(698 321)">
            <g transform="translate(37)">
              <rect
                width="396"
                height="346"
                x="0"
                y="0"
                fill="#F8F8F8"
                rx="8"
              />
              <path fill="#CCC" d="M8 0h380a8 8 0 018 8v19H0V8a8 8 0 018-8z" />
              <g fill="#F8F8F8" transform="translate(9 10)">
                <circle cx="4" cy="4" r="4" />
                <circle cx="16" cy="4" r="4" />
                <circle cx="28" cy="4" r="4" />
              </g>
              <g transform="translate(16 43)">
                <g transform="translate(294 89)">
                  <rect
                    width="70"
                    height="194"
                    x="0"
                    y="0"
                    fill="#FFF"
                    rx="8"
                  />
                  <g transform="translate(18 18)">
                    <rect
                      width="34"
                      height="26"
                      x="0"
                      y="0"
                      fill="#EEE"
                      rx="4"
                    />
                    <rect
                      width="34"
                      height="25"
                      x="0"
                      y="34"
                      fill="#ABB"
                      rx="4"
                    />
                    <rect
                      width="34"
                      height="25"
                      x="0"
                      y="67"
                      fill="#EEE"
                      rx="4"
                    />
                    <rect
                      width="34"
                      height="25"
                      x="0"
                      y="133"
                      fill="#EEE"
                      rx="4"
                    />
                    <rect
                      width="34"
                      height="25"
                      x="0"
                      y="100"
                      fill="#CCC"
                      rx="4"
                    />
                  </g>
                </g>
                <g transform="translate(294)">
                  <rect width="70" height="81" x="0" y="0" fill="#FFF" rx="8" />
                  <g fill="#EEE" transform="translate(10 15)">
                    <circle cx="25" cy="16" r="16" />
                    <rect width="50" height="6" x="0" y="36" rx="3" />
                    <rect width="34" height="6" x="8" y="46" rx="3" />
                  </g>
                </g>
                <g>
                  <g>
                    <rect
                      width="286"
                      height="47"
                      x="0"
                      y="0"
                      fill="#FFF"
                      rx="4"
                    />
                    <g fill="#EEE" transform="translate(9 14.1)">
                      <rect width="228" height="7.05" x="0" y="0" rx="3" />
                      <rect
                        width="153.041"
                        height="7.05"
                        x="0"
                        y="11.75"
                        rx="3"
                      />
                    </g>
                    <g transform="translate(248.435 16.5)">
                      <circle cx="7" cy="7" r="7" fill="#EEE" />
                      <circle cx="7" cy="7" r="3" fill="#F8F8F8" />
                    </g>
                  </g>
                  <g transform="translate(0 55)">
                    <rect
                      width="286"
                      height="39"
                      x="0"
                      y="0"
                      fill="#FFF"
                      rx="4"
                    />
                    <g fill="#EEE" transform="translate(9 11.7)">
                      <rect width="228" height="5.85" x="0" y="0" rx="2.925" />
                      <rect
                        width="153.041"
                        height="5.85"
                        x="0"
                        y="9.75"
                        rx="2.925"
                      />
                    </g>
                    <g transform="translate(248.435 12.5)">
                      <circle cx="7" cy="7" r="7" fill="#EEE" />
                      <circle cx="7" cy="7" r="3" fill="#F8F8F8" />
                    </g>
                  </g>
                  <g transform="translate(0 102)">
                    <rect
                      width="286"
                      height="39"
                      x="0"
                      y="0"
                      fill="#FFF"
                      rx="4"
                    />
                    <g fill="#EEE" transform="translate(9 11.7)">
                      <rect width="228" height="5.85" x="0" y="0" rx="2.925" />
                      <rect
                        width="153.041"
                        height="5.85"
                        x="0"
                        y="9.75"
                        rx="2.925"
                      />
                    </g>
                    <g transform="translate(248.435 12.5)">
                      <circle cx="7" cy="7" r="7" fill="#EEE" />
                      <circle cx="7" cy="7" r="3" fill="#F8F8F8" />
                    </g>
                  </g>
                  <g transform="translate(0 243)">
                    <rect
                      width="286"
                      height="39"
                      x="0"
                      y="0"
                      fill="#FFF"
                      rx="4"
                    />
                    <g fill="#EEE" transform="translate(9 11.7)">
                      <rect width="228" height="5.85" x="0" y="0" rx="2.925" />
                      <rect
                        width="153.041"
                        height="5.85"
                        x="0"
                        y="9.75"
                        rx="2.925"
                      />
                    </g>
                    <g transform="translate(248.435 12.5)">
                      <circle cx="7" cy="7" r="7" fill="#EEE" />
                      <circle cx="7" cy="7" r="3" fill="#F8F8F8" />
                    </g>
                  </g>
                  <g transform="translate(0 196)">
                    <rect
                      width="286"
                      height="39"
                      x="0"
                      y="0"
                      fill="#FFF"
                      rx="4"
                    />
                    <g fill="#EEE" transform="translate(9 11.7)">
                      <rect width="228" height="5.85" x="0" y="0" rx="2.925" />
                      <rect
                        width="153.041"
                        height="5.85"
                        x="0"
                        y="9.75"
                        rx="2.925"
                      />
                    </g>
                    <g transform="translate(248.435 12.5)">
                      <circle cx="7" cy="7" r="7" fill="#EEE" />
                      <circle cx="7" cy="7" r="3" fill="#F8F8F8" />
                    </g>
                  </g>
                  <g transform="translate(0 149)">
                    <rect
                      width="286"
                      height="39"
                      x="0"
                      y="0"
                      fill="#FFF"
                      rx="4"
                    />
                    <g fill="#EEE" transform="translate(9 11.7)">
                      <rect width="228" height="5.85" x="0" y="0" rx="2.925" />
                      <rect
                        width="153.041"
                        height="5.85"
                        x="0"
                        y="9.75"
                        rx="2.925"
                      />
                    </g>
                    <g transform="translate(248.435 12.5)">
                      <circle cx="7" cy="7" r="7" fill="#EEE" />
                      <circle cx="7" cy="7" r="3" fill="#F8F8F8" />
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g transform="matrix(-1 0 0 1 470 114)">
              <g transform="matrix(-1 0 0 1 470 .883)">
                <g transform="rotate(-8 130.527 -292.969)">
                  <path
                    fill="#B28B67"
                    strokeWidth="1"
                    d="M29.935 7.16c4.548 8.467 4.007 29.943-1.87 31.457-2.344.603-7.337-.875-12.42-3.935l3.19 22.541H0l6.483-30.188C2.868 22.795.42 17.6.83 11.778 2.008-4.997 25.387-1.307 29.935 7.16z"
                    transform="translate(42.38 24.3)"
                  />
                  <path
                    fill="#164"
                    d="M64.875 22.239c-2.574-.784-6.31-1.05-7.882-.87.894-2.14 1.249-4.523.96-6.844-.281-2.256-1.29-4.176-2.223-6.188-.43-.928-.918-1.85-1.645-2.56-.74-.722-1.677-1.2-2.66-1.427-1.005-.233-2.057-.214-3.064-.002-.446.093-.845.297-1.282.41-.448.116-.665-.164-.99-.445-.782-.677-1.93-1.012-2.92-1.131-1.111-.135-2.264.033-3.323.397-1.032.356-2.023.932-2.768 1.772-.332.374-.634.8-.83 1.27-.08.193-.093.307-.286.378-.178.065-.386.067-.57.13-1.778.6-3.299 1.973-4.127 3.735-.483 1.028-.711 2.838-.649 4.867.063 2.028 1.897 7.321 3.612 9.252 1.531 1.723 3.781 2.86 5.953 3.358-1.441 1.646-2.401 3.703-3.11 5.794a28.325 28.325 0 00-1.425 7.038c-.167 2.286-.182 4.702.354 6.939.502 2.091 1.575 3.807 3.366 4.896.82.498 1.704.873 2.592 1.215.875.338 1.753.666 2.67.855 1.734.358 3.733.297 5.07-1.083.481-.497 1.011-1.122 1.362-1.73.127-.218.203-.36.05-.574-.184-.256-.482-.452-.718-.652-1.347-1.14-2.181-2.663-2.391-4.473-.214-1.836.28-4.206 2.067-5.007 2.207-.99 4.636.146 6.597 1.205.833-2.938 2.544-5.583 5.227-6.931 2.968-1.49 6.374-1.665 9.424-2.944.795-.334 1.604-.712 2.19-1.391.244-.284.53-.652.628-1.028.129-.493-.19-.906-.436-1.29-1.304-2.04-6.25-6.157-8.823-6.941z"
                  />
                </g>
                <g transform="translate(0 151.886)">
                  <path
                    fill="#997659"
                    d="M102.02439 0L160.340286 97.3789203 204.06043 179.704589 213.477362 179.704589 140.223647 3.99024345e-13z"
                  />
                  <g fill="#CCC" transform="translate(196.2 155.992)">
                    <path d="M1.935 20.364C1.168 22.48.785 24.08.785 25.167c0 1.414.236 3.476.707 6.188h44.264c1.15-3.798.487-5.849-1.992-6.152a245.42 245.42 0 01-6.176-.82l-20.372-9.071a1 1 0 00-1.331.532l-1.238 3c-2.294 1.069-4.159 1.603-5.593 1.603-1.09 0-2.567-.41-4.432-1.232a2 2 0 00-2.687 1.149z" />
                  </g>
                  <path
                    fill="#ABB"
                    d="M191.918 166.522l18.16-5.487c-7.956-23.758-17.708-49.903-29.255-78.434C169.276 54.069 156.874 26.536 143.619 0H92.327c14.738 33.567 30.36 64.066 46.87 91.498 16.51 27.433 34.083 52.44 52.721 75.024z"
                  />
                  <path
                    fill="#B28B67"
                    d="M98.192 0c-5.504 34.22-16.12 77.94-17.121 79.288-.668.9-24.712 8.947-72.132 24.142l2.034 8.295c56.548-8.15 86.344-14.472 89.388-18.968 4.566-6.744 27.364-60.02 36.195-92.757H98.192z"
                  />
                  <path
                    fill="#CCC"
                    d="M25.608 96.26l3.583 13.36c42.294 3.704 68.21 1.027 77.745-8.032C116.47 92.528 127.338 58.666 139.537 0h-48.91c-7.729 48.04-12.05 73.067-12.963 75.084C76.751 77.1 59.4 84.159 25.608 96.26z"
                  />
                  <g fill="#CCC" transform="rotate(80 -41.009 65.392)">
                    <path d="M1.935 20.364C1.168 22.48.785 24.08.785 25.167c0 1.414.236 3.476.707 6.188h44.264c1.15-3.798.487-5.849-1.992-6.152a245.42 245.42 0 01-6.176-.82l-20.372-9.071a1 1 0 00-1.331.532l-1.238 3c-2.294 1.069-4.159 1.603-5.593 1.603-1.09 0-2.567-.41-4.432-1.232a2 2 0 00-2.687 1.149z" />
                  </g>
                </g>
                <g transform="rotate(-8 613.669 11.765)">
                  <path
                    fill="#997659"
                    d="M187.22 36.378c3.4-.7 11.7-6.864 13.13-5.613 2.115 1.852.229 7.539-1.994 10.368-4.154 5.286-7.593 7.094-16.095 9.462-4.444 1.238-9.25 3.72-14.417 7.444l-.681-11.994 11.966-6.566c1.678-6.38 3.685-9.591 6.02-9.631 1.794-.834-1.33 7.23 2.07 6.53zm-20.595-27.33l-.292.52c-2.088 3.741-3.99 7.623-2.921 8.77 1.12 1.2 3.91-.477 5.246 1.517.89 1.33-3.878 3.43-14.306 6.3L134.56 44.255l-10.06-10.784 27.24-14.902c4.53-5.373 8.994-9.546 13.39-12.519 1.344-.56 3.693-.899 1.496 2.996z"
                  />
                  <path
                    fill="#164"
                    d="M112.115 27.237c9.44 1.393 22.321 1.395 37.076-4.983l3.408 12.564c-10.7 7.703-24.899 13.176-36.22 11.056-8.921-1.67-11.786-13.223-4.264-18.637z"
                    transform="rotate(-9 130.198 34.294)"
                  />
                  <path
                    fill="#285"
                    d="M111.869 0c1.201 15.418 7.249 32.41 12.212 49.197 10.128 2.524 27.114-.452 50.958-8.926 5.914 12.22 8.648 20.933 8.202 26.137-20.456 10.673-37.989 15.43-52.433 15.744.465 8.557-.578 16.703-4.083 24.147-7.204 15.3-49.387 1.13-63.57 3.92-8.882-28.812 8.292-40.52 8.306-58.956C71.476 31.075 87.705 0 90.093 0z"
                  />
                </g>
              </g>
              <g>
                <g transform="rotate(7 34.98 666.574)">
                  <path
                    fill="#B28B67"
                    strokeWidth="1"
                    d="M29.935 7.16c4.548 8.467 4.007 29.943-1.87 31.457-2.344.603-7.337-.875-12.42-3.935l3.19 22.541H0l6.483-30.188C2.868 22.795.42 17.6.83 11.778 2.008-4.997 25.387-1.307 29.935 7.16z"
                    transform="translate(42.38 24.3)"
                  />
                  <path
                    fill="#164"
                    d="M61.579 21.702c-2.483-.407-9.167-.686-10.4-.686-.787 0-1.64.18-2.107-.543-.382-.591-.242-1.592-.356-2.278-.133-.798-.32-1.585-.511-2.37-.541-2.235-1.36-4.36-2.505-6.357-2.15-3.744-5.298-6.677-9.272-8.384C32.039-.801 27.073-1.232 22.352-.85 17.3-.44 12.726 1.225 7.956 2.792 3.411 4.286-1.35 4.874-6.104 4.145c-4.79-.735-8.41-3.328-12.45-5.79-4.136-2.519-8.863-4.167-13.752-3.788-4.564.354-8.771 2.236-12.545 4.75-3.531 2.353-6.445 5.184-8.09 9.168-1.77 4.285-1.768 8.99 1.142 12.776 4.218 5.49 12.049 6.91 18.563 6.769a35.505 35.505 0 0011.027-2.019c4.745-1.667 8.845-4.492 13.283-6.784 2.084-1.076 4.237-1.959 6.494-2.595 2.19-.618 4.347-.902 6.33.42 2.097 1.398 3.977 2.771 6.377 3.646 2.302.84 4.74 1.31 7.193 1.29 4.772-.036 9.476-1.521 14.111-2.516 3.78-.811 7.824-1.62 11.677-.84 1.608.325 3.957.997 4.537 2.666-9.774 1.77-13.613 13.843-10.857 22.707 1.487 4.784 10.427 10.376 13.903 7.861 2.202-1.593.865-3.685 0-5.066-1.657-2.644-2.224-6.04.842-7.882 2.644-1.588 5.425 2.183 5.477 2.179.727-.057 7.008-3.605 11.335-8.782 4.269.252 4.916-2.559 3.897-4.858-1.02-2.3-7.381-5.193-10.811-5.755z"
                  />
                </g>
                <g transform="translate(0 152.77)">
                  <path
                    fill="#B28B67"
                    d="M162.752-7.616c-14.99 12.224-9.226 119.476-10.226 120.826-.445.6-24.21 5.693-71.293 15.28l2.037 8.302c55.081-2.705 84.226-6.101 87.434-10.19 4.593-5.853 10.256-38.6 16.988-98.242l-24.94-35.976z"
                    transform="rotate(-55 134.462 64.588)"
                  />
                  <path
                    fill="#CCC"
                    d="M89.176 119.757l3.588 13.371c41.062 4.74 68.127-1.084 77.65-10.145 6.348-6.041 12.026-38.7 17.032-97.976l-26.68-38.102c-35.685 26.924-14.356 115.14-15.267 117.158-.912 2.018-22.565 3.602-56.323 15.694z"
                    transform="rotate(-55 138.311 60.861)"
                  />
                  <g fill="#CCC" transform="rotate(20 -272.204 510.489)">
                    <path d="M1.935 20.364C1.168 22.48.785 24.08.785 25.167c0 1.414.236 3.476.707 6.188h44.264c1.15-3.798.487-5.849-1.992-6.152a245.42 245.42 0 01-6.176-.82l-20.372-9.071a1 1 0 00-1.331.532l-1.238 3c-2.294 1.069-4.159 1.603-5.593 1.603-1.09 0-2.567-.41-4.432-1.232a2 2 0 00-2.687 1.149z" />
                  </g>
                  <path
                    fill="#997659"
                    d="M102.02439 0L61.4140036 97.3789203 21.5003144 179.704589 30.9172455 179.704589 133.945222 0z"
                  />
                  <g fill="#CCC" transform="translate(18.835 155.992)">
                    <path d="M1.935 20.364C1.168 22.48.785 24.08.785 25.167c0 1.414.236 3.476.707 6.188h44.264c1.15-3.798.487-5.849-1.992-6.152a245.42 245.42 0 01-6.176-.82l-20.372-9.071a1 1 0 00-1.331.532l-1.238 3c-2.294 1.069-4.159 1.603-5.593 1.603-1.09 0-2.567-.41-4.432-1.232a2 2 0 00-2.687 1.149z" />
                  </g>
                  <path
                    fill="#EEE"
                    d="M25.105 162.602l20.924 3.92C62.208 142.764 129.917 45.349 137.341 0H90.758C65.967 32.783 40.526 138.452 25.105 162.602z"
                  />
                </g>
                <g transform="rotate(7 -466.935 249.67)">
                  <path
                    fill="#B28B67"
                    d="M40.424 64.278l16.082 3.187c-16.173 30.105-24.847 46.061-26.02 47.867-2.64 4.065-.177 11.513.733 15.436-5.71 1.327-3.458-7.256-10.683-5.464-6.595 1.636-12.186 5.834-18.336.172-.756-.696-1.309-2.872 1.269-3.987 6.422-2.78 15.91-7.986 17.448-10.007 2.098-2.756 8.6-18.49 19.507-47.204zm159.064-24.1c-2.529 3.689-5.023 7.683-4.012 8.975 1.01 1.293 3.937-.134 5.093 1.969.771 1.401-4.162 3.078-14.8 5.03l-21.298 16.31-9.08-11.62 28.437-12.473c4.981-4.959 9.792-8.727 14.431-11.306 1.387-.44 3.757-.574 1.229 3.115z"
                  />
                  <path
                    fill="#58A184"
                    d="M96.755 7.747l6.659-1.75c15.973 12.979 24.98 46.73 35.19 50.408 9.654 3.478 22.443-1.824 37.586-8.797l5.722 10.266c-12.861 16.592-41.987 32.207-54.901 25.877-20.646-10.12-28.872-51.999-30.256-76.004z"
                    transform="rotate(5 139.334 45.594)"
                  />
                  <path
                    fill="#EEE"
                    d="M70.632 89.362h60.047c2.744 0 2.226-3.957 1.83-5.954-4.578-23.046-22.447-47.89-22.447-80.695L92.742 0c-14.326 23.013-19.28 51.348-22.11 89.362z"
                  />
                  <path
                    fill="#6B9"
                    d="M98.482 0c15.549 52.94 19.836 88.215 12.86 105.824H57.29c.855-12.886 3.597-26.512 7.353-39.798-12.24 22.056-22.53 37.934-30.868 47.637L21.19 111.2C29.297 60.98 52.775 23.912 91.624 0z"
                  />
                </g>
              </g>
            </g>
            <g transform="rotate(-14 675.195 -511.103)">
              <path
                fill="#CCC"
                d="M50.828 54.607l-.007.016c.003-.005.007-.025.007-.016"
              />
              <path fill="#CCC" d="M50.823 54.614v.005c0-.005.008-.02 0-.005" />
              <path
                fill="#CCC"
                d="M50.858 54.53c-.007.02-.016.039-.024.059l.012-.028a5.5 5.5 0 01.012-.031"
              />
              <path
                fill="#CCC"
                d="M50.836 54.59l-.012.028c-.03.056.012-.028.012-.028"
              />
              <path
                fill="#CCC"
                d="M50.8245383 54.6140786L50.8245383 54.6140786 50.8245383 54.6130786z"
              />
              <path fill="#CCC" d="M50.824 54.615l.001-.002-.001.002" />
              <path fill="#CCC" d="M50.82 54.622c-.007.012.027-.046 0 0" />
              <path fill="#CCC" d="M50.824 54.615l.002-.002-.002.002" />
              <rect
                width="100"
                height="66"
                x="0.575"
                y="0.818"
                fill="#1B7"
                rx="4"
              />
              <g
                fill="#000"
                fillOpacity="0.2"
                transform="translate(9.058 20.093)"
              >
                <path d="M29.3115079 0L0.47121868 47 58.1517972 47z" />
                <path d="M59.0474583 12.5892857L33.5509707 47 84.543946 47z" />
              </g>
              <circle cx="79.017" cy="23.642" r="9.5" fill="#FFF" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export { Illustration }
